/**
 * Preloader
 */
class TpPreloader {
    /**
     * Initializes the preloader by setting up an event listener for the window's load event.
     * When the window finishes loading, it will wait for 300 milliseconds before fading out the preloader.
     */
    constructor() {
        window.onload = () => {
            setTimeout(() => {
                this._fadeout();
            }, 300);
        }
    }

    /**
     * Fades out the preloader.
     *
     * Sets the opacity of the preloader to 0 and hides it.
     */
    _fadeout() {
        document.querySelector('.preloader').style.opacity = '0';
        document.querySelector('.preloader').style.display = 'none';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new TpPreloader();
});
